import type { CanvasState, Frame, Rect } from './types';

export function selectedFrames(s: CanvasState): Frame[] {
  const set = new Set(s.selection);
  return s.doc.frames.filter(f => set.has(f.id));
}

export function boundsOf(frames: Frame[]): Rect | null {
  if (frames.length === 0) return null;
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (const f of frames) {
    const h = f.h ?? 200;
    minX = Math.min(minX, f.x);
    minY = Math.min(minY, f.y);
    maxX = Math.max(maxX, f.x + f.w);
    maxY = Math.max(maxY, f.y + h);
  }
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}

/**
 * Read-only query: ids of every InstanceFrame whose mainId === the given id.
 * Used by the agent's `find_instances` preview tool before running batch ops.
 */
export function instancesOf(s: CanvasState, mainId: string): string[] {
  const out: string[] = [];
  for (const f of s.doc.frames) {
    if ((f.kind === 'instance' || f.kind === 'tsxInstance') && f.mainId === mainId) out.push(f.id);
  }
  return out;
}
